import { Component, Input, Injector } from '@angular/core';

import { GenericListComponent } from '@core/globals/generic-list/generic-list.component';
import { SignalsService } from '@core/services/signals.service';


@Component({
  selector: 'app-invoice-notes-tab',
  templateUrl: './invoice-notes.component.html',
  styles: []
})
export class InvoiceNotesComponent extends GenericListComponent {
  @Input() public company: any;

  public api: any;
  public localFilters: any;
  public loadingItemAction = false;
  public editionInProgress = false;

  public newNote: any = null;

  constructor(private signalsService: SignalsService, public injector: Injector) {
    super(injector);
  }

  public ngOnInit(): void {
    this.api = this.apiShiva.invoice_notes;
    this.localFilters = { company__code: this.company.code };
  }

  public showAddForm(): void {
    this.newNote = { code: '', content: '', position: '' };
    this.editionInProgress = true;
  }

  public cancelAdd(): void {
    this.newNote = null;
    this.editionInProgress = false;
  }

  public addInvoiceNote(): void {
    if (!this.newNote?.code || !this.newNote?.content) {
      return;
    }

    this.loadingItemAction = true;
    this.apiShiva.invoice_notes.create({
      company: this.company.id,
      code: this.newNote.code,
      content: this.newNote.content,
      position: this.newNote.position
    })
      .then((res) => {
        this.company.invoice_notes = [...(this.company.invoice_notes || []), res];
        this.cancelAdd();
        this.signalsService.broadcast('company-invoice-notes-list-refresh');
      })
      .catch(() => {
        this.toastr.error("Erreur lors de l'ajout de la mention.");
      })
      .finally(() => {
        this.loadingItemAction = false;
      });
  }

  public edit(item): void {
    item._original = { code: item.code, content: item.content, position: item.position };
    item.editable = true;
    this.editionInProgress = true;
  }

  public cancelEdit(item): void {
    item.code = item._original.code;
    item.content = item._original.content;
    item.position = item._original.position;
    delete item._original;
    item.editable = false;
    this.editionInProgress = false;
  }

  public save(item): void {
    this.loadingItemAction = true;
    this.apiShiva.invoice_notes.update(item.id, { code: item.code, content: item.content, position: item.position })
      .then((res: any) => {
        item.code = res.code;
        item.content = res.content;
        item.position = res.position;
        delete item._original;
        item.editable = false;
        this.editionInProgress = false;
        this.signalsService.broadcast('company-invoice-notes-list-refresh');
      })
      .catch(() => {
        this.toastr.error('Erreur lors de la mise à jour de la mention.');
      })
      .finally(() => {
        this.loadingItemAction = false;
      });
  }

  public confirmDelete(item): void {
    this.loadingItemAction = true;
    this.apiShiva.invoice_notes.delete(item.id)
      .then(() => {
        this.company.invoice_notes = this.company.invoice_notes.filter((note) => note.id !== item.id);
        this.signalsService.broadcast('company-invoice-notes-list-refresh');
      })
      .catch(() => {
        this.toastr.error('Erreur lors de la suppression de la mention.');
      })
      .finally(() => {
        this.loadingItemAction = false;
      });
  }
}
